/** @format */

import {
  createMuiTheme,
  MuiThemeProvider,
  Step,
  StepButton,
  Stepper,
} from "@material-ui/core"
import React from "react"
import ConfirmedDriver from "./ConfirmedDriver"
import FifthStep from "./FifthStep"
import FourthStep from "./FourthStep"
import SecondStep from "./SecondStep"
import ThirdStep from "./ThirdStep"

export default (props) => {
  const [activeStep, setActiveStep] = React.useState(0)
  const [completed, setCompleted] = React.useState({ 0: false })
  const [currentStep, setCurrentStep] = React.useState(2)
  const [edit, setEdit] = React.useState(false)

  const muiTheme = createMuiTheme({
    overrides: {
      MuiStepConnector: {
        root: {
          height: "3.3px",
          borderRadius: "5px",
          "&$active": {
            background: "#6dd06d",
          },
        },
      },
      MuiStepIcon: {
        root: {
          color: "darkgray", // or 'rgba(0, 0, 0, 1)'
          "&$active": {
            color: "#6dd06d",
          },
          "&$completed": {
            color: "#6dd06d",
          },
          fontSize: "35px",
          display: "block",
        },
        text: {
          fontFamily: "sans",
        },
      },
      MuiStepLabel: {
        root: {
          display: "block",
          color: "red", // or 'rgba(0, 0, 0, 1)'
          "&$active": {
            color: "green",
          },
          "&$completed": {
            color: "#6dd06d",
          },
        },
        iconContainer: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "5px",
        },
        label: {
          "&$active": {
            color: "#6dd06d",
            fontWeight: "bolder",
          },
          "&$completed": {
            color: "#6dd06d",
          },
        },
      },
    },
  })

  const steps = [
    <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
      <span> مشخصات </span> <span className="d-none d-md-inline"> مالک</span>
    </h4>,
    <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
      <span> وسیله </span> <span className="d-none d-md-inline"> مشخصات </span>
    </h4>,
    <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
      <span> آپلود </span> <span className="d-none d-md-inline"> مدارک</span>
    </h4>,
    <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
      <span> مشخصات </span>
      <span className="d-none d-md-inline"> رانندگان</span>
    </h4>,
    <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
      <span className="d-none d-md-inline">نهایی </span>
      <span> تایید </span>
    </h4>,
  ]

  // console.log("steps.length", steps.length)
  const totalSteps = () => {
    return steps.length
  }
  console.log("Object.keys(completed).length", Object.keys(completed).length)
  const completedSteps = () => {
    return Object.keys(completed).length
  }

  const isLastStep = () => {
    return activeStep === totalSteps() - 1
  }

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps()
  }

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted() + 1
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1
    setActiveStep(newActiveStep)
  }

  const handleComplete = async () => {
    const newCompleted = completed
    newCompleted[activeStep] = true
    setCompleted(newCompleted)
    // props.stepOBJ.setCurrentStep((prevActiveStep) => `${prevActiveStep + 1}`)
    setCurrentStep(currentStep + 1)
    handleNext()
    console.log("CurrentStep", currentStep)
  }

  const handleBack = () => {
    setCurrentStep(currentStep - 1)
    setEdit(true)
  }

  const componentSituationSetter = () => {
    switch (currentStep) {
      case 1:
        console.log("sssss1")
        break
      case 2:
        console.log("ssss2")

        return (
          <SecondStep
            stepEdit={{ edit, setEdit }}
            handleComplete={handleComplete}
          />
        )

      case 3:
        console.log("ssss3")
        return (
          <ThirdStep
            stepEdit={{ edit, setEdit }}
            handleComplete={handleComplete}
            handleBack={handleBack}
          />
        )
      case 4:
        console.log("ssss4")
        return (
          <FourthStep
            stepEdit={{ edit, setEdit }}
            handleComplete={handleComplete}
            handleBack={handleBack}
          />
        )

      case 5:
        return (
          <FifthStep
            stepEdit={{ edit, setEdit }}
            handleComplete={handleComplete}
            handleBack={handleBack}
          />
        )
      case 6:
        return <ConfirmedDriver />
    }
  }

  return (
    <>
      <div
        className="row"
        style={{ backgroundColor: "#6dd06d", height: "3rem" }}
      ></div>
      <div className="bg-white row">
        <div className="container">
          <MuiThemeProvider theme={muiTheme}>
            <Stepper
              nonLinear
              style={{ overflow: "auto" }}
              activeStep={activeStep}
            >
              {steps.map((label, index) => (
                <Step key={label} completed={completed[index]}>
                  <StepButton
                    color="white"
                    style={{ color: "white", display: "block" }}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
          </MuiThemeProvider>
        </div>
      </div>
      <div className="container-fluid" style={{ marginBlock: "2rem 3rem" }}>
        <div
          className="bg-white"
          style={{
            borderRadius: "13px",
            boxShadow: "0px 0px 10px #d9d9d9",
            height: "fit-content",
            minHeight: "10rem",
            height: "fit-content",
          }}
        >
          {componentSituationSetter()}
        </div>
      </div>
    </>
  )
}
